/** Barn tiers — animal capacity + the cost to reach each level (0 = the basic barn). */
export const BARN_CAP = [8, 16, 28];

export interface BarnUpgrade {
  cost: { gold: number; items?: { itemId: string; qty: number }[] };
}
/** Cost to go from level i → i+1. */
export const BARN_UPGRADES: BarnUpgrade[] = [
  { cost: { gold: 1500, items: [{ itemId: 'wood', qty: 25 }] } },
  { cost: { gold: 6000, items: [{ itemId: 'wood', qty: 40 }, { itemId: 'iron_bar', qty: 8 }] } },
];

export const barnCapacity = (level: number): number => BARN_CAP[Math.min(level, BARN_CAP.length - 1)]!;
